export const EXSBBATCHNUMBER_CREATE_RESET = 'EXSBBATCHNUMBER_CREATE_RESET'
export const EXSBBATCHNUMBER_CREATE_SET_CREATED = 'EXSBBATCHNUMBER_CREATE_SET_CREATED'
export const EXSBBATCHNUMBER_CREATE_SET_ERROR = 'EXSBBATCHNUMBER_CREATE_SET_ERROR'
export const EXSBBATCHNUMBER_CREATE_SET_VIOLATIONS = 'EXSBBATCHNUMBER_CREATE_SET_VIOLATIONS'
export const EXSBBATCHNUMBER_CREATE_TOGGLE_LOADING = 'EXSBBATCHNUMBER_CREATE_TOGGLE_LOADING'
